import { Pipe, PipeTransform } from '@angular/core';

import { MomentHelper } from '@global/helpers/moment-helper';

@Pipe({ name: 'shortDateTime', pure:  true })
export class ShortDateTimePipe implements PipeTransform {

	transform(value: string, args?: any[]): string {
		return MomentHelper.stringToShortDateTime(value);
	}
}
